module.exports = __webpack_public_path__ + "img/fb15.7e49214f.jpg";